const handlePriceSammaryOpen = ()=>{
   document.querySelector(".price-summary-wrapper").classList.toggle("open");
   document.querySelector(".calculation-of-saving").classList.toggle("open");
}

const handleInputChange = (e)=> {
  const aplBtn =document.getElementById("apply_with_btn")
  aplBtn.disabled = e.target.value.trim() === "";
}

const discountModalopen = async ()=>{
   document.querySelector(".discount-modal").classList.add("open-offer");
   
       
             
}
const discountModalclose = ()=>{
   document.querySelector(".discount-modal").classList.remove("open-offer");
}

// for gift modal
function hadleModelOpen(ref_class){
    element = document.getElementsByClassName(ref_class)[0]
    if(element){
        element.classList.remove("d-none")
    }
}
function handleModelClose(ref_class){
    element = document.getElementsByClassName(ref_class)[0]
    if(element){
        element.classList.add("d-none")
    }
    
}
async function reloadActionButton(productId) {

    const wrapper = document.getElementById(`actionbtnloader-${productId}`);

    if (!wrapper) return;

    const response = await fetch(window.location.pathname);
    const html = await response.text();

    const parser = new DOMParser();
    const doc = parser.parseFromString(html, "text/html");

    const newWrapper = doc.getElementById(`actionbtnloader-${productId}`);

    if (newWrapper) {
        wrapper.innerHTML = newWrapper.innerHTML;
    }
}


async function handleCustomcartAdd(variantId, productId ,giftProductIds , numberOfGift) {
    const addBtn = document.getElementById(`add-btn-${productId}`);
    addBtn.disabled = true;
    if( giftProductIds > 1 ||  numberOfGift > 1){
        const cart = await fetch('/cart.js').then(res => res.json());
            let giftCount = 0;
            cart.items.forEach(item => {
                if (giftProductIds.includes(item.product_id)) {
                giftCount++;
                }
        });

        const alreadyInCart = cart.items.some(
            item => item.product_id == productId
        );

        if (giftCount >= numberOfGift && !alreadyInCart) {
            const msg = document.querySelector('.maximum-gift-msg');
            msg.classList.remove('d-none');
            setTimeout(() => {
              msg.classList.add('d-none');
            }, 2000);
            addBtn.disabled = false;
            return;
        }
        // Don't allow the same free gift to be added twice
        // if (alreadyInCart) {
        //     const msg = document.querySelector('.maximum-gift-msg');
        //     msg.innerText = "This free gift has already been added.";
        //     msg.classList.remove('d-none');

        //     setTimeout(() => {
        //         msg.classList.add('d-none');
        //     }, 2000);

        //     addBtn.disabled = false;
        //     return;
        // }

        // Don't allow more than the maximum number of gifts
        // if (giftCount >= numberOfGift) {
        //     const msg = document.querySelector('.maximum-gift-msg');
        //     msg.innerText = "Maximum free gifts reached.";
        //     msg.classList.remove('d-none');

        //     setTimeout(() => {
        //         msg.classList.add('d-none');
        //     }, 2000);

        //     addBtn.disabled = false;
        //     return;
        // }
     }
     try {
        document.querySelector('.gift-loader').classList.remove('d-none');
        await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            id: variantId,
            quantity: 1
          })
        });
  } finally {
    await reloadActionButton(productId);
    document.querySelector('.gift-loader').classList.add('d-none');
    addBtn.disabled = false;
    // const addBtn = document.getElementById(`add-btn-${productId}`);
    // const removeBtn = document.getElementById(`remove-btn-${productId}`);
    // addBtn?.classList.add('d-none');
    // removeBtn?.classList.remove('d-none');
    document.dispatchEvent(
      new CustomEvent('cart:refresh', {
        detail: {
          open: true,
          onlyItems: true
        }
      })
    );
  }
    
}
async function handleCustomcartremove(variantId, productId ) {
  document.querySelector('.gift-loader').classList.remove('d-none');
  try{
      await fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        id: variantId,
        quantity: 0
      })
    });
  } finally{
    await reloadActionButton(productId);
    document.querySelector('.gift-loader').classList.add('d-none');
    // const addBtn = document.getElementById(`add-btn-${productId}`);
    // const removeBtn = document.getElementById(`remove-btn-${productId}`);
    // removeBtn?.classList.add('d-none');
    // addBtn?.classList.remove('d-none');
    document.dispatchEvent(
      new CustomEvent('cart:refresh', {
        detail: {
          open: true,
          onlyItems: true
        }
      })
    );
  }
 
}

async function removeGiftProductsIfThresholdNotMet(cart) {
  const updates = {};

  if (cart.total_price < 18000 * 100) {
    const item = cart.items.find(
      item => item.product_id == 9166053245178
    );

    if (item) {
      updates[item.variant_id] = 0;
    }
  }

  if (cart.total_price < 15000 * 100) {
    const item = cart.items.find(
      item => item.product_id == 8743089897722
    );

    if (item) {
      updates[item.variant_id] = 0;
    }
  }

  if (cart.total_price < 7000 * 100) {
    const item = cart.items.find(
      item => item.product_id == 15401286598906
    );

    if (item) {
      updates[item.variant_id] = 0;
    }
  }

  if (cart.total_price < 3000 * 100) {
    cart.items.forEach(item => {
      if (item.final_price === 0) {
        updates[item.variant_id] = 0;
      }
    });
  }

  if (!Object.keys(updates).length) {
    return;
  }

   try {
    document.querySelector('.gift-loader').classList.remove('d-none');
    await fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        updates
      })
    });

    document.dispatchEvent(
      new CustomEvent('cart:refresh', {
        detail: { open: true }
      })
    );

  } catch (error) {
    console.error(error);
  } finally {
    document.querySelector('.gift-loader').classList.add('d-none');
  }
}
document.addEventListener('cart:updated', async (event) => {
  await removeGiftProductsIfThresholdNotMet(event.detail.cart);
});